export const CLIENT_ID = "1097626550837-qot7dfq8v2nretj7halgnfhtuerjii05.apps.googleusercontent.com"